// extracted by mini-css-extract-plugin
export default {"appsMenuList":"AppsMenu_appsMenuList__1gIQt"};